import React from "react";

const About = (props) => {
  return (
    <div className="article-container" id="about-container">
      {/* Refresh the page in case the stream below doesn't work. <br />
      <div id="video-container"><video id="video" controls muted autoplay></video></div> */}
      <h2>What's this all about?</h2>
      <div>
        Hello~! We are the »Leipzig League of Livecoding« (or »LOL2«) and we are
        a bunch of people interested in programming languages, open-source
        software, creative coding, creating{" "}
        <strong>algorithmic music and generative visuals</strong> etc. etc. and
        we are having a kind of inaugural event for our livecoding league very
        soon: <br />
        ヽ(*^ｰ^)人(^ｰ^*)ノ
        <br /> On
        <strong> December 1 and 2, 2023</strong> we will celebrate our »Binary
        Blast« αﾚg⊕rα∀ε event at{" "}
        <span onClick={() => props.setModal("hitness")}>Hitness Club</span> in
        Leipzig — with concerts, presentations, live streams, workshops and lots
        of nice stuff. It's all about doing cool stuff with a computer and we
        try not to be too geeky (just a little), so that you can participate and
        have fun even without being a hacker.{" "}
      </div>
      <img
        id="poster"
        src="/assets/Binary_Blast(2).jpg"
        alt="a person with a TV set as a head that explods into a mushroom cloud"
      />
      <div>
        These events should function as a place to connect and establish a
        network of like-minded people and such with an interest in creative
        usages of coding and programming. If you are new to the game, don't be
        shy. We are always happy about new people joining in and introducing you
        to the coding world.
      </div>
      <div>
        If you want to <strong>get in touch with us</strong>, share your stuff,
        or join our league, don't hesitate to send a mail to:
        <br />
        <address>algorave-leipzig@inventati.org</address>
        <br />
        ...or join{" "}
        <a
          href="https://discord.gg/CPs6KcMBk6"
          target="_blank"
          rel="noopener noreferrer"
        >
          our Discord server
        </a>
        .
      </div>
      <div className="about-image-container">
        <p onClick={() => props.setModal("algorave")}>
          <img alt="Algorave logo" src="/assets/algorave.gif" />
          <span hidden>ALGORAVE</span>
        </p>
        <a
          href="https://hitness.club/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="Hitness Club logo" src="/assets/hitness.gif" />
          <span hidden>Hitness Club</span>
        </a>
        <p>
          <img
            id="bb-logo"
            src="/assets/bb_logo.gif"
            alt="glitchy logo for Binary Blast"
          />
        </p>
        <a
          href="https://discord.gg/CPs6KcMBk6"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="LOL2 logo" src="/assets/lol2.gif" />
          <span hidden>LOL2</span>
        </a>
        <a
          href="https://forum.toplap.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img alt="TOPLAP logo" src="/assets/toplap.gif" />
          <span hidden>TOPLAP</span>
        </a>
      </div>
    </div>
  );
};
export default About;
